<span
  class="status-whatsapp"
  [matTooltip]="tooltipStatus"
  matTooltipPosition="below"
  [class.status-whatsapp--verde]="corStatus === 'green'"
  [class.status-whatsapp--laranja]="corStatus === 'orange'"
  [class.status-whatsapp--vermelho]="corStatus === 'red'"
  [class.status-whatsapp--verificando]="corStatus === 'loading'"
  aria-label="Status do BOT WhatsApp"
>
  <span class="status-whatsapp__bolinha" aria-hidden="true"></span>
</span>
